// extracted by mini-css-extract-plugin
export var compact = "RatingFooterLinks-module--compact--8d61f";
export var content = "RatingFooterLinks-module--content--850f0";
export var iconWrap = "RatingFooterLinks-module--iconWrap--fdd84";
export var inline = "RatingFooterLinks-module--inline--5c8b7";
export var linksWrap = "RatingFooterLinks-module--linksWrap--5e6d7";
export var logoLinksWrap = "RatingFooterLinks-module--logoLinksWrap--f776b";
export var root = "RatingFooterLinks-module--root--b1562";
export var stars = "RatingFooterLinks-module--stars--ff873";
export var text = "RatingFooterLinks-module--text--b4b61";